import React, { useEffect, useState } from 'react';
import { Box, Grid, Paper, Typography, CircularProgress, Tooltip } from '@mui/material';
import GroupIcon from '@mui/icons-material/Group';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import WarningIcon from '@mui/icons-material/Warning';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import MonetizationOnIcon from '@mui/icons-material/MonetizationOn';
import AssignmentTurnedInIcon from '@mui/icons-material/AssignmentTurnedIn';
import QueryBuilderIcon from '@mui/icons-material/QueryBuilder';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import axios from 'axios';

const Dashboard = () => {
  const [data, setData] = useState({
    activeUsers: 0,
    totalOrders: 0,
    lowStockAlerts: 0,
    pendingDeliveries: 0,
    totalPendingAmount: 0,
    monthlyTotalOrders: 0,
    monthlyDeliveredOrders: 0,
    monthlyPendingOrders: 0,
  });

  const [loading, setLoading] = useState(true);
  const user = JSON.parse(localStorage.getItem('user'));
  const email = user ? user.email : '';
  const name = user ? user.firstName : '';

  useEffect(() => {
    const fetchDashboardData = async () => {
      try {
        const response = await axios.get('https://citi-mobile-app.onrender.com/admin/dashboard-data', {
          params: { email },
        });
        setData({
          ...response.data,
        });
        setLoading(false);
      } catch (error) {
        console.error('Error fetching dashboard data:', error);
        setLoading(false);
      }
    };

    if (email) {
      fetchDashboardData();
    }
  }, [email]);

  const formatNumber = (num) => {
    return num.toLocaleString('en-US', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  };

  const cardData = [
    { title: 'Active Users', value: data.activeUsers, icon: <GroupIcon fontSize="large" style={{ color: '#4caf50' }} /> },
    { title: 'Total Orders', value: data.totalOrders, icon: <ShoppingCartIcon fontSize="large" style={{ color: '#2196f3' }} /> },
    { title: 'Low Stock Alerts', value: data.lowStockAlerts, icon: <WarningIcon fontSize="large" style={{ color: '#f44336' }} /> },
    { title: 'Pending Deliveries', value: data.pendingDeliveries, icon: <LocalShippingIcon fontSize="large" style={{ color: '#ff9800' }} /> },
    { title: 'Pending Amount (₦)', value: `₦${formatNumber(data.totalPendingAmount)}`, icon: <MonetizationOnIcon fontSize="large" style={{ color: '#9c27b0' }} /> },
    { title: 'Orders This Month', value: data.monthlyTotalOrders, icon: <CalendarMonthIcon fontSize="large" style={{ color: '#00bcd4' }} /> },
    { title: 'Delivered This Month', value: data.monthlyDeliveredOrders, icon: <AssignmentTurnedInIcon fontSize="large" style={{ color: '#4caf50' }} /> },
    { title: 'Pending This Month', value: data.monthlyPendingOrders, icon: <QueryBuilderIcon fontSize="large" style={{ color: '#ff5722' }} /> },
  ];

  return (
    <div className="ml-60 max-sm:ml-0 max-sm:mt-20">
      <Typography
        variant="h4"
        sx={{
          fontWeight: 'bold',
          color: '#1E1E1E',
          marginBottom: { xs: '1.5rem', md: '2rem' },
        }}
      >
        Welcome back, {name}
      </Typography>

      <Box sx={{ flexGrow: 1 }}>
        <Grid container spacing={3}>
          {cardData.map((item, index) => (
            <Grid item xs={12} sm={6} md={4} lg={3} key={index}>
              <Paper
                elevation={3}
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  justifyContent: 'center',
                  height: 140,
                  p: 2,
                  borderRadius: 4,
                  textAlign: 'center',
                  transition: 'transform 0.2s ease, box-shadow 0.2s ease',
                  '&:hover': {
                    transform: 'scale(1.05)',
                    boxShadow: '0px 8px 20px rgba(0, 0, 0, 0.15)',
                  },
                }}
              >
                {loading ? (
                  <CircularProgress />
                ) : (
                  <>
                    <Tooltip title={item.title}>
                      <Box>{item.icon}</Box>
                    </Tooltip>
                    <Typography variant="h6" sx={{ mt: 1, fontSize: { xs: '1rem', md: '1.25rem' } }}>
                      {item.title}
                    </Typography>
                    <Typography
                      variant="h4"
                      sx={{
                        fontSize: { xs: '1.5rem', md: '2rem' },
                        color: '#333',
                        fontWeight: 'bold',
                      }}
                    >
                      {item.value}
                    </Typography>
                  </>
                )}
              </Paper>
            </Grid>
          ))}
        </Grid>
      </Box>
    </div>
  );
};

export default Dashboard;